import { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import Modal from "../modal";
import { actualizaPantalla, getPantallaInt,  } from "../../services/pantalla";
import { ErrorContext } from "../../utils/context/error";

function PantallaModal({ show, AreaI, AreaFId, DispensaI, Tag, handleshow, handleFiltrar }) {

  const [habilita, setHabilita] = useState(false);
  const [areaId, setAreaId] = useState(0);
  const [pantallaId, setPantallaId] = useState(0);
  const [proyecta, setProyecta] = useState(0);
  const [tipollamado, setTipoLlamado] = useState(0);
  const [nombrePant, setNombrePant]= useState("");
  const [area, setArea] = useState([]);
  const [codigovinc, setCodigoVinc] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [Titulo, setTitulo] = useState("");
  const [llamVoz, setLlamaVoz] = useState("NO");
  const { setShowToast, setOpciones } = ErrorContext();
  
  //---  Boton Cancelar
  const handleCancel = async () => 
    {
     handleshow(false);
    };
 
  //--- Boton Aceptar
  const handleAceptar = async () => {
    setHabilita(true);
    setShowToast(false);
    const response = await actualizaPantalla({
      areaId,
      pantallaId,
      nombrePant,
      descripcion,
      proyecta,
      llamVoz,
      codigovinc,
      Tag,
      tipollamado,
    });

    if (response) {
      if (response.status === 200) {
        handleFiltrar(AreaFId);
        handleshow(false);
      } else {
        const Mensaje = response.message;
        const opc = { type: "Danger", message: Mensaje, active: true };
        setOpciones(opc);
        setShowToast(true);
      }
    }
    setHabilita(false);
  };

//---- Servicio por area e Id
 const fillDispensaInt = async (AreaId, pantallaId) => {
    setShowToast(false);
    const response = await getPantallaInt(AreaId, pantallaId);
    if (response) {
      if (response.status === 200) {
         setNombrePant(response.data.data[0]?.NombrePant||"");
         setCodigoVinc(response.data.data[0]?.CodigoVinc||"");
         setDescripcion(response.data.data[0]?.Descripcion||"");
         setProyecta(response.data.data[0]?.Proyecta||"");
         setLlamaVoz(response.data.data[0]?.llamVoz);
         setTipoLlamado(response.data.data[0]?.Tipollamado);
         setAreaId(AreaI);
         setPantallaId(DispensaI);
         setArea(response.data.area);
         if (Tag === 0) setCodigoVinc(generarClave(8));
  
      } else {
        const Mensaje = response.message;
        const opc = { type: "Danger", message: Mensaje, active: true };
        setOpciones(opc);
        setShowToast(true);
      }
    }
  };

//-----------
const Random = (array) => {
  let posicionActual = array.length;

  while (0 !== posicionActual) {
    const posicionAleatoria = Math.floor(Math.random() * posicionActual);
    posicionActual--;
    //"truco" para intercambiar los valores sin necesidad de una variable auxiliar
    [array[posicionActual], array[posicionAleatoria]] = [
      array[posicionAleatoria], array[posicionActual]];
  }
  return array;
}

//-----------
function generarClave(cantidad) {
  const caracteres = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@%/?!=&$*+".split("");
  Random(caracteres);
  return caracteres.slice(0,cantidad).join("")
}

//---------
  useEffect(() => {
    if (show) {
      setNombrePant("");
      setDescripcion("");
      setLlamaVoz("NO");
      setProyecta(0);
      setTipoLlamado(0);
      setAreaId(AreaI);
      setPantallaId(DispensaI);
      fillDispensaInt(AreaI, DispensaI);
      
      if (Tag !== 0) {
        if (Tag === 1) setTitulo("Editar Pantalla (" + DispensaI + ")");
        if (Tag === 2) setTitulo("Eliminar Pantalla (" + DispensaI + ")");
      } else {
        setPantallaId(0);
        setTitulo("Nueva Pantalla");
      }
    }
  }, [show]);

  return (
    <>
      <Modal isOpen={show} onClose={()=>handleshow(false)} title={Titulo}>
          <div className="flex lg:w-[25rem]">
              <form noValidate className="flex flex-col w-full">
                  <div className="flex flex-col w-full h-full ">
                      <div className="w-full">
                        <label>Area</label>
                        <select id="area" name="area" value={areaId || 0} onChange={(e) => setAreaId(e.target.value)} label="Area" disabled={Tag === 2 || Tag === 1}>
                          <option value={0} disabled>
                            Seleccionar una Area...
                          </option>
                              {area.map((item) => 
                                {
                                   return(
                                       <option key={item.AreaId} value={item.AreaId}>
                                          {item.NombreArea}
                                       </option>
                                      );
                                }
                                )
                              }
                        </select>
                      </div>

                      <div className="w-full mt-4">
                         <label>Nombre Pantalla</label>
                            <input type="text" name='searchid' value={nombrePant || ""} placeholder="Ingresa el nombre para la Pantalla" 
                                onChange={(e)=> setNombrePant(e.target.value)}
                                autoComplete="off" 
                                disabled={Tag === 2}>
                            </input>
                      </div>

                      <div className="w-full mt-4">
                         <label>Descripcion</label>
                            <textarea name='searchid' value={descripcion || ""} placeholder="Ingresa una Descripcion" 
                                onChange={(e)=> setDescripcion(e.target.value)}
                                autoComplete="off" 
                                
                                disabled={Tag === 2}>
                            </textarea>
                      </div>
                      
                      <div className=" flex flex-row w-full mt-2 space-x-4">
                         <div className="flex w-full flex-col">
                             <label>Tipo Llamado</label>
                             <select id="tipopantalla" name="tipopantalla" value={tipollamado || 0} onChange={(e) => setTipoLlamado(Number(e.target.value))} label="Area" disabled={Tag === 2}>
                                 <option value={0} disabled>
                                    Seleccionar...
                                 </option>
                                 <option value={1}>
                                    Llamado de Turnos
                                 </option>
                                 <option value={2}>
                                    Llamado Consultas Médicas 
                                 </option>
                                 <option value={3}>
                                   Llamado Turnos/Consultas
                                 </option>                              
                             </select>
                          </div>

                         <div className="flex w-full flex-col">
                             <label>Proyectar</label>
                             <select id="proyecta" name="proyecta" value={proyecta || 0} onChange={(e) => setProyecta(Number(e.target.value))} label="Area" disabled={Tag === 2}>
                                 <option value={0} disabled>
                                    Seleccionar...
                                 </option>
                                 <option value={1}>
                                    Slider
                                 </option>
                                 <option value={2}>
                                    Videos
                                 </option>
                                 <option value={3}>
                                   Página Web
                                 </option>                              
                             </select>
                          </div>
                      </div>
                      <div className="w-full mt-2">
                         <label>Código de Vinculación</label>
                            <input type="text" name='searchid' value={codigovinc || ""} placeholder="Ingresa el nombre para el Dispensador" 
                                onChange={(e)=> setCodigoVinc(e.target.value)}
                                autoComplete="off" 
                                disabled={Tag === 2}>
                            </input>
                      </div>
                      <div className="flex mt-4">
                         <input type="checkbox" className="mr-2" checked={llamVoz === "SI"} onChange={(e) => e.target.checked ? setLlamaVoz("SI") : setLlamaVoz("NO")}/>
                         <label className="">Activar llamado por voz</label>   
                     </div>

                     <div className="flex w-full gap-4 mt-6 justify-end">
                          <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                          <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
                     </div>
                  </div>
              </form>
          </div>
      </Modal>         
    </>
  );
}
PantallaModal.propTypes = {
  show: PropTypes.bool.isRequired,
  AreaI: PropTypes.number.isRequired, 
  AreaFId: PropTypes.number.isRequired, 
  DispensaI: PropTypes.number.isRequired,
  Tag: PropTypes.number.isRequired,
  handleshow: PropTypes.func.isRequired,
  handleFiltrar: PropTypes.func.isRequired,
};

export default PantallaModal;
